<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="500px"
                   maxHeight="500px"
                   useContentFullHeight
                   useClickOutsideClose
                   @close="handleClose">
            <template #header />
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <div class="general-modal__image">
                        <i class="fa-solid fa-user-shield user-shield-icon" />
                    </div>
                    <div class="general-modal__title">
                        <Translate translation-key="quests-dashboard.completeConnectingWithMetamask"
                                   fallback="Complete Connecting With Metamask" />
                    </div>
                    <div class="general-modal__subtitle">
                        <Translate translation-key="quests-dashboard.clickMetamaskWallet"
                                   fallback="Click the button below to continue connecting with Metamask Wallet." />
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton :variant="ButtonVariantEnum.METAMASK"
                                    @click.stop="handleMetamaskConnect">
                            <span class="button-icon-wrapper">
                                <img :src="asset_cdn('assets/auth/metamask.svg')"
                                     alt="Metamask logo"
                                     title="Metamask logo">
                            </span>
                            <span class="button-text-wrapper">
                                <Translate translation-key="quests-dashboard.completeConnection"
                                           fallback="Complete Connection" />
                            </span>
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { ButtonVariantEnum } from '@/js/types/components/ButtonVariantEnum';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';
    import { deleteAuthTypeQueryParam } from '@/js/quests/global/helpers/queryParamHelpers';
    import { connectToMetamask } from '@/js/auth/helpers/walletConnectHelpers';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { useWeb3Store } from '@/js/store/web3/Web3Store';

    const web3Store = useWeb3Store();
    const modalStore = useModalStore();
    const { isMobileOrTablet } = useDeviceSize();

    const handleClose = () => {
        deleteAuthTypeQueryParam();
        modalStore.toggleModal(ModalEnum.METAMASK_AUTH, false);
    };

    const handleMetamaskConnect = () => {
        connectToMetamask(web3Store.otpCode);
        handleClose();
    };

    useModalActive();
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;
@use "@/sass/design-system/fonts" as fonts;

.general-modal {
    @include modalMixins.modal;

    &__content {
        font-family: fonts.$font-quicksand;
    }
}

.user-shield-icon {
    margin-bottom: 16px;
    color: legacyVariables.$orange;
    font-size: 80px;
}

.button-icon-wrapper {
    @include modalMixins.modal-button-icon-wrapper;
}

.button-text-wrapper {
    @include modalMixins.modal-button-text-wrapper;
}
</style>
